import { UserAccessFeatures, UserPermission, UserProfile } from 'types/authContext';
import { env } from 'utils/env';
import { isProd } from 'utils/environments';

export const noUserFeaturesAccess: UserAccessFeatures = {
    capacityFactorView: false,
    contractMixView: false,
    departmentsView: () => false,
    modulation: () => false,
    recruitmentNeedsView: false,
};

export const hasDepartmentsViewAccess = (userProfile: UserProfile | null, currentCountry: string | undefined) => {
    if (!currentCountry || !userProfile?.rolePermissions.includes(UserPermission.DEPARTMENTS_VIEW)) {
        return false;
    }
    if (isProd) {
        // TODO - Adjust when this is moved to BE or remove if depreciated
        return !!env.VITE_APP_FEATURES_enable_department_markets?.split(',').includes(currentCountry);
    }

    return true;
};

const hasCapacityFactorsAccess = (userProfile: UserProfile | null) => !!userProfile?.rolePermissions.includes(UserPermission.CAPACITY_FACTOR_VIEW);

const hasContractMixAccess = (userProfile: UserProfile | null) => !!userProfile?.rolePermissions.includes(UserPermission.READ_CONTRACT_MIX);

const hasModulationAccess = (currentCountry: string | undefined) => {
    if (!currentCountry) {
        return false;
    }

    return !!env.VITE_APP_FEATURES_modulation_countries?.split(',').includes(currentCountry);
};

const hasRecruitmentNeedsAccess = (userProfile: UserProfile | null) => !!userProfile?.rolePermissions.includes(UserPermission.VIEW_RECRUITMENT_NEEDS);

/**
 * Handles whether the user, given the current environment and role, has access to each feature on the site
 */
export const getAccessFeatures = (userProfile: UserProfile | null): UserAccessFeatures => {
    if (!userProfile) return noUserFeaturesAccess;

    return {
        departmentsView: (currentCountry: string | undefined) => hasDepartmentsViewAccess(userProfile, currentCountry),
        capacityFactorView: hasCapacityFactorsAccess(userProfile),
        contractMixView: hasContractMixAccess(userProfile),
        modulation: (currentCountry: string | undefined) => hasModulationAccess(currentCountry),
        recruitmentNeedsView: hasRecruitmentNeedsAccess(userProfile)
    };
};
